import { useLocaleStore } from '@/stores/Locale.store'
import type { Composer } from 'vue-i18n'
import lvDayjs from '@/utils/dayjs/locales/lv'
import enDayjs from '@/utils/dayjs/locales/en'
import deDayjs from '@/utils/dayjs/locales/de'

export default defineNuxtPlugin((nuxtApp) => {
  const i18n = nuxtApp.$i18n as Composer
  const locale = i18n.locale.value || 'en'

  const localeStore = useLocaleStore()
  localeStore.initCookies()
  localeStore.setSelectedLanguage(locale)

  const dayjs = useDayjs()

  dayjs.updateLocale('de', { ...deDayjs })
  dayjs.updateLocale('lv', { ...lvDayjs })
  dayjs.updateLocale('en', { ...enDayjs })

  dayjs.locale(locale)
})
